import React from 'react';

import { DarkSkeleton } from '@eika/skeleton';

const LoanRepaymentPlanSkeletonMobileItem: React.FC = () => {
    return (
        <li className="loan-repayment-plan-skeleton-mobile-item">
            {Array.from(Array(5)).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div className="loan-repayment-plan-skeleton-mobile-item__row" key={index}>
                    <DarkSkeleton height={index === 0 ? 21 : 17} width={70 + index * ((index + 1) % 2) * 10} />
                    <DarkSkeleton height={index === 0 ? 21 : 17} width={70 + index * ((index + 1) % 2) * 10} />
                </div>
            ))}
        </li>
    );
};

export default LoanRepaymentPlanSkeletonMobileItem;
